import { API_BASE_URL } from '../constants/api';
import { authFetch } from './api';

export const login = async (credentials) => {
  const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Une erreur est survenue');
  return data;
};

export const register = async (data) => {
  const response = await fetch(`${API_BASE_URL}/api/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Une erreur est survenue');
  return result;
};

export const changePassword = async (payload) => {
  const response = await authFetch('/api/auth/change-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result.message || 'Impossible de changer le mot de passe.');
  }

  return result;
};

export const revokeAllSessions = async () => {
  const response = await authFetch('/api/auth/revoke-sessions', {
    method: 'POST'
  });

  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result.message || 'Impossible de révoquer les sessions.');
  }

  return result;
};

export const sendVerificationCode = async (email) => {
  const response = await fetch(`${API_BASE_URL}/api/auth/send-verification-code`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Une erreur est survenue');
  return result;
};

export const verifyCode = async (email, code) => {
  const response = await fetch(`${API_BASE_URL}/api/auth/verify-code`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code }),
  });

  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Une erreur est survenue');
  return result;
};

export const resendVerificationCode = async (email) => {
  const response = await fetch(`${API_BASE_URL}/api/auth/resend-code`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Une erreur est survenue');
  return result;
};
